<template>
  <div>
    <button v-b-modal.photoModal type="button" :class="pclass" :style="pstyle">{{ptext}}</button>
    <b-modal id="photoModal" ref="photoModal" title="Upload Photo"
			scrollable centered button-size="sm"
			:ok-disabled="loading"
			:cancel-disabled="loading"
      @show="resetModalPhoto"
			@hidden="resetModalPhoto"
      @ok="handleOk"
      @cancel="handleCancel" >
			<form name="frmPhoto" ref="frmPhoto" class="form-horizontal">
				<div v-if="message" role="alert" class="alert" :class="successful ? 'alert-success' : 'alert-danger'">{{message}}</div>
				<div class="form-group">
					<div class="col-xs-12" style="margin-bottom: 5px;">
						<div v-if="filePhoto" class="progress progress-sm">
							<div class="progress-bar bg-success" role="progressbar" aria-valuemin="0" aria-valuemax="100"
								:aria-valuenow="uploadProgress"
								:style="{ width: uploadProgress + '%' }"
							>{{ uploadProgress }}%</div>
						</div>
					</div>
					<div class="col-xs-12">
						<b-form-file v-model="filePhoto" ref="pfile" @change="selectedFile" :accept="paccept" drop-placeholder="Drop photo here..."></b-form-file>
					</div>
				</div>
			</form>
		</b-modal>
  </div>
</template>

<script>
import { BModal, VBModal } from 'bootstrap-vue';

export default {
  name: "photo-upload",
  components: {
		'b-modal': BModal,
	},
	directives: {
    // Note that Vue automatically prefixes directive names with `v-`
    'b-modal': VBModal
  },
  props: ['ptext', 'pclass', 'pstyle', 'paccept', 'pminwidth', 'pminheight', 'pmaxsize'],
  data() {
    return {
      submitted: false,
			loading: false,
			successful: false,
      message: '',
      filePhoto: null,
      uploadProgress: 0,
      it: '',
      iw: 0,
      ih: 0,
      is: 0,
    };
  },
  methods: {
    resetModalPhoto() {
			this.submitted = false;
			this.loading = false,
			this.successful = false;
			this.message = '';
			this.filePhoto = null;
      this.uploadProgress = 0;
      this.it = '';
      this.iw = 0;
      this.ih = 0;
      this.is = 0;
    },
    selectedFile() {
      // console.log("In selectedFile");
      //console.log(this.$refs.pfile);
      let file = this.$refs.pfile.$refs.input.files[0];
      //console.log(file);
      if(!file || file.type.indexOf('image/') !== 0) {
        this.message = 'Photo is require';
				this.successful = false;
        return false;
      }
      this.it = file.type;
      this.is = file.size;
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = evt => {
        let img = new Image();
        img.onload = () => {
          this.iw = img.width;
          this.ih = img.height;
        }
        img.src = evt.target.result;
      }
      reader.onerror = evt => {
        console.error(evt);
      }
    },
    checkFormUpload() {
      // console.log("it: " + this.it); // image/jpeg | image/png
      // console.log("iw: " + this.iw);
      // console.log("ih: " + this.ih);
      // console.log("is: " + this.is);
      // console.log("pminwidth: " + this.pminwidth);
      // console.log("pminheight: " + this.pminheight);
      // console.log("pmaxsize: " + this.pmaxsize);
      // console.log("niceSize: " + this.niceSize(this.pmaxsize));
      // console.log("it.indexOf: " + this.it.indexOf('image/jpeg'));
      if(this.filePhoto == null) {
        this.message = 'Photo is require';
				this.successful = false;
        return false;
      }
      if(this.it.indexOf('image/jpeg') !== 0 && this.it.indexOf('image/png') !== 0) {
        this.message = 'Only accept image type jpg or png';
				this.successful = false;
        return false;
      }
      if((this.pminwidth && this.iw < this.pminwidth) || (this.pminheight && this.ih < this.pminheight)) {
        this.message = 'Width x Height image is at least ' + this.pminwidth + ' x ' + this.pminheight;
				this.successful = false;
        return false;
      }
      if(this.pmaxsize && this.is > this.pmaxsize) {
        this.message = 'Size image is maximum ' + this.niceSize(this.pmaxsize);
				this.successful = false;
        return false;
      }
			return true;
    },
    niceSize(s) {
      var i = 0;
      var byteUnits = [' bytes', ' kB', ' MB', ' GB', ' TB', ' PB', ' EB', ' ZB', ' YB'];
      while (s > 1024) {
        s = s / 1024;
        i++;
      }
      return Math.max(s, 0.1).toFixed(1) + byteUnits[i];
    },
    handleProgress(progress) {
      this.uploadProgress = progress;
    },
    handleSuccess(success) {
      this.message = success;
      this.successful = true;
      this.submitted = false;
      setTimeout(() => {
        // Hide the modal manually
        this.$nextTick(() => {
          this.$bvModal.hide('photoModal');
          this.loading = false;
        });
      }, 3000);
    },
    handleFailure(failure) {
      this.message = failure;
      this.successful = false;
      this.submitted = false;
      this.loading = false;
    },
    handleOk(bvModalEvt) {
			this.submitted = true;
			this.loading = true;
      // Prevent modal from closing
      //console.log(bvModalEvt);
			bvModalEvt.preventDefault();
			// Exit when the form isn't valid
			// console.log('this.checkFormUpload():' + this.checkFormUpload());
			// emit ok event
      if (this.checkFormUpload()) {
        this.$emit('ok:upload', this.filePhoto, this.handleProgress, this.handleSuccess, this.handleFailure);
      } else {
        setTimeout(() => {
          this.loading = false;
					this.message = '';
				}, 3000);
      }
    },
    handleCancel() {
      // Prevent modal from closing
      //bvModalEvt.preventDefault();
      // emit cancel event
      this.$emit('cancel:upload', "");
    },
  }
}
</script>
